<script>
import CandelaComponent from '@/components/CandelaComponent'
export default {
  data() {
    return {
      bounds: {
        h: 0,
        w: 0,
        x: 0,
        y: 0
      }
    }
  },
  extends: CandelaComponent,
  methods: {
    update() {
      const plot = this.$refs.plot
      const axis = this.$refs.axis
      this.bounds.h = axis ? axis.scale.range()[0] : 0
      this.bounds.w = 20
      this.bounds.x = plot ? plot.content_bounds.width - this.bounds.w : 0
      this.bounds.y = axis ? axis.scale.range()[1] : 0
    }
  },
  name: 'GradientLegend',
  props: {
    x: {type: Object, default: () => ({})}
  }
}
</script>

<template>
<candela-plot ref='plot' :id='id' :frame='frame' @update='update'
  :bound_rect_visible='false' :clip_content='false' :min_width='100'>
  <linearGradient :id='`${id}-gradient-legend`'
    slot='def-1' x1='0%' y1='100%' x2='0%' y2='0%'>
    <stop v-for='i in 32' :key='`gradient-stop-${i}`'
      :offset='(i-1)/31' :stop-color='settings.spectrum.value((i-1)/31)'/>
  </linearGradient>
  <candela-axis ref='axis' slot='axis_y2' v-bind='x' :nice='true'/>
  <g slot='content'>
  <rect stroke='black' stroke-width='1' :fill='`url(#${id}-gradient-legend)`'
      :width='bounds.w' :height='bounds.h' :x='bounds.x' :y='bounds.y'/>
  </g>
</candela-plot>
</template>
